// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falWindowMinimize: CreateIconOptions = {
  "displayName": "FALWindowMinimize",
  "viewBox": "0, 0, 512, 512",
  "d": "M16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l480 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 448z"
};
